let debounce = require('lodash/debounce');

export default function textSearchClassInit(coreHandlerInstance, paramInstance, searchRegexInstance) {
  const coreHandler = coreHandlerInstance;
  const targetClassName = ".js__search-text";
  let targetElement = document.querySelector(targetClassName) || null;
  const outputArea = document.getElementById("js__search-list");
  const outputAreaBody = document.getElementById("js__search-list-body");
  const outputInput = document.getElementsByClassName("js__text-search")[0];
  const resetButton = document.getElementById("js__search-reset-btn");
  const paramHandler = paramInstance;
  const searchRegex = searchRegexInstance;

  if (targetElement === null) return false;

  class TextValue {
    static instanceList = [];
    constructor(ele, value) {
      this.data = {
        "Type": ele.getAttribute('data-type') ? ele.getAttribute('data-type').toLowerCase() : null,
        "PropertyId": 30260,
        "Text": value
      };
    }
  }

  class TextSearchClass {
    static instance;
    static recentSearch = [];
    static input = outputInput;

    static init = () => {
      TextSearchClass.instance = new TextSearchClass(targetElement);
      TextSearchClass.resetInit();
    };

    static sanitize = (str) => {
      return String(str).replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/　/g, " ");
    }

    static paramLoad = (searchTextList) => {
      if (searchTextList.length > 0) {
        let wordList = searchTextList[0].Text;
        let keyword;
        if (wordList.length > 0) {
          keyword = wordList.join(" ");
        }
        TextSearchClass.instance.addFilterEvent(keyword, false, false);
      }
    }

    static allReset = () => {
      TextSearchClass.instance.input.value = "";
      while (outputAreaBody.firstChild) {
        outputAreaBody.removeChild(outputAreaBody.firstChild);
      }
      outputArea.style.display = "none";
    }

    static resetInit = () => {
      return resetButton.addEventListener("click", () => {
        coreHandler.allReset();
      });
    };

    static recalculate = () => {
      TextSearchClass.instance.positionCalculate();
    }

    static inputClear = () => {
      TextSearchClass.input.value = "";
    }

    
    static checkRecentSearch = (value) => {
      if (Array.isArray(TextSearchClass.recentSearch)) {
        const index = TextSearchClass.recentSearch.findIndex(entry => entry.value === value);
        return index !== -1 ? { index: index + 1, object: TextSearchClass.recentSearch[index] } : { index: 0, object: null };
      } else {
        console.error('TextSearchClass.recentSearch is not an array.');
        return { index: 0, object: null }; // エラー時は0を返す（または他の処理を追加）
      }
    };

    static checkRecentTypeSearch = (type) => {
      if (Array.isArray(TextSearchClass.recentSearch)) {
        const index = TextSearchClass.recentSearch.findIndex(entry => entry.type === type);
        return index !== -1 ? { index: index + 1, object: TextSearchClass.recentSearch[index] } : false;
      } else {
        console.error('TextSearchClass.recentSearch is not an array.');
        return false; // エラー時は0を返す（または他の処理を追加）
      }
    };


    // 修正: 最近の検索値をセットする
    static setRecentSearch = (dataObject, type) => {
      const entry = {
        value:dataObject,
        type: type
      };
      TextSearchClass.recentSearch.push(entry);
    };

    // 修正: 特定の位置の最近の検索値を削除する
    static removeRecentSearch = (data) => {
      if (data.index >= 1 && data.index <= TextSearchClass.recentSearch.length) {
        TextSearchClass.recentSearch.splice(data.index - 1, 1); // 1から始まる位置で削除
      }
    };

    constructor(ele) {
      this.instanceType = "TextSearchClass";
      this.ele = ele;
      this.input = this.ele.querySelector('input');
      this.button = this.ele.querySelector('button');
      this.sendHandler = this.addFilterEvent.bind(this);
      this.data = null;
      this.keyWord = null;

      this.button.addEventListener("click", () => {
        this.sendHandler(this.input.value, true, true);
        if (this.isSmartPhone() === true) {
          this.scrollEvent();
        }
        TextSearchClass.inputClear();
      });

      this.input.addEventListener("keypress", (e) => {
        if (e.keyCode === 13) {
          this.addFilterEvent(this.input.value, true, true);
          TextSearchClass.inputClear();
          if (this.isSmartPhone() === true) {
            this.scrollEvent();
          }
        }
      });

      this.target = document.getElementById("js__out");
      this.topPosition = null;

      this.positionCalculate = () => {
        const space = 30;
        let header = document.querySelector(".l-header__fix") || null;
        if (header) {
          this.topPosition = this.target.getBoundingClientRect().top + window.pageYOffset - header.clientHeight - space;
        } else {
          this.topPosition = this.target.getBoundingClientRect().top + window.pageYOffset - space;
        }
      };

      window.addEventListener("load", this.positionCalculate);
      window.addEventListener("resize", debounce(this.positionCalculate, 300));

    }

    getLanguage = () => {
      const htmlElement = document.querySelector('html');
      const langAttributeValue = htmlElement.getAttribute('lang');
      return langAttributeValue;
    }

    addFilterEvent = (value, sendFlag, paramFlag) => {
      if (value) {
        let keyWord = TextSearchClass.sanitize(value);
        let keyData = keyWord.split(/\s/);
        keyData = keyData.filter(v => v != 0 || Boolean(v));

        if (keyData.length > 0) {
          keyData = keyData.map(v => {
            let word = this.wordConversion(v);
            return new TextValue(this.ele, word);
          });
          TextValue.instanceList = keyData;
          this.data = keyData;
          this.keyWord = keyWord;

          this.removeFilterEvent(keyData, false);
          this.removeLabel(keyData);

          const checkData = TextSearchClass.checkRecentTypeSearch("textSearch");

          if (checkData !== false) {
            TextSearchClass.removeRecentSearch(checkData);
            let keyDataObject = checkData.object.value;
            
            this.removeFilterEvent(keyDataObject);
            paramHandler.remove(this);
          }
          
          TextSearchClass.setRecentSearch(keyData, "textSearch");

          this.setFilterEvent(keyData);
          this.addSelectList(keyData, keyWord);
          paramHandler.add(this);

          if (sendFlag !== false) {
            coreHandler.sendClickEvent();
          }
          if(paramFlag === true ){
            this.dataLayerEvent(keyWord);
          }
          this.input.value = "";
        }
      }
    }

    dataLayerEvent = (keyWord) => {
      dataLayer.push({
        'event': 'gradeSearchPageTextFilter',
        'value': keyWord,
        'sessionId': this.input.getAttribute("data-session")
      });
    }

    wordConversion = (str) => {
      const reonaReg = /(レオナ|れおな|雷鸥娜)/g;
      const xyronReg = /(ザイロン|ざいろん|采龙)/g;
      const tenacReg = /(テナック|てなっく|铁耐克)/g;
      return str.replace(reonaReg, "leona").replace(xyronReg, "xyron").replace(tenacReg, "tenac");
    }

    addSelectList = (keyData, keyWord) => {
      if (keyData[0].data.Type != "text") return false;

      const labelText = keyWord ? keyWord : null;
      const newButton = document.createElement("button");

      newButton.className = "p-label js__search-label";
      newButton.setAttribute('data-property-id', keyData[0].data.PropertyId);
      newButton.setAttribute('data-val', keyWord);

      let newSpan = document.createElement("span");
      newSpan.innerHTML = "<span class=\"material-icons-outlined p-material-icon\">close</span> " + labelText;
      newButton.appendChild(newSpan);
      outputAreaBody.appendChild(newButton);
      outputArea.style.display = "flex";

      newButton.addEventListener("click", () => {
        this.removeEvent(keyData);
      }, true);
    }

    removeEvent = (data) => {
      this.removeLabel(data);
      this.removeFilterEvent(data);
      paramHandler.remove(this);
      coreHandler.sendClickEvent("text");
    }

    setFilterEvent = (keyData) => {
      keyData.forEach(v => coreHandler.setFilter(v.data));
    }

    removeFilterEvent = (keyData, allResetFlag = false) => {
      keyData.forEach(v => coreHandler.removeFilter(v.data, allResetFlag));
    }

    removeLabel = (keyData) => {
      let labelList = outputAreaBody.querySelectorAll(".js__search-label");
      let removeItemSearch = [...labelList].filter(v => {
        return v.getAttribute("data-property-id") == keyData[0].data.PropertyId;
      });

      if (removeItemSearch.length > 0) {
        [...removeItemSearch].map(v => {
          outputAreaBody.removeChild(v);
        })
      }

      labelList = outputArea.querySelectorAll(".js__search-label");

      if (labelList.length < 1) {
        outputArea.style.display = "none";
      }
    }

    scrollEvent = () => {
      window.scrollTo({
        top: this.topPosition,
        behavior: 'smooth'
      });
    };

    isSmartPhone = () => {
      if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
        return true;
      } else {
        return false;
      }
    }
  }

  TextSearchClass.init();
  return TextSearchClass;
};